import React from "react";

export interface AccessibleSVGProps {
    className?: string;
    id: string;
    title: string;
    children: any;
}

// Do not use this svg for decorative icons, use it only for semantic icons
//This svg icon will add title and aria-labelledby attribute and aria-hidden will be false
const Item: React.FunctionComponent<AccessibleSVGProps> = ({ className, id, title, children }: AccessibleSVGProps) => {

    return (
      <svg className={className} viewBox="0 0 24 24" role="img" aria-labelledby={id}>
        <title id={id}>{title}</title>
        {children}
      </svg>
    );
};

export const AccessibleSVG = Item;